var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from '@material-ui/core';
import React from 'react';
import { Paper } from '@mui/material';
export var GridFieldAloneView = function (_a) {
    var children = _a.children;
    return (_jsx(Grid, __assign({ item: true, xs: 12, style: { marginBottom: '15px', paddingRight: '0px', paddingLeft: '1px' } }, { children: _jsx(Paper, __assign({ sx: { borderRadius: 2, overflow: 'hidden', width: '100%', padding: '16px', paddingRight: '23px' } }, { children: children })) })));
};
